<div class="px-4 sm:px-8 lg:px-[74px] py-6 sm:py-10">
  <h2 class="text-2xl sm:text-3xl text-gray-900 text-center font-bold mb-6">Create an image from text prompt</h2>
  <div class="flex mb-6">
    <div class="w-[800px] max-w-full mx-auto">
      <form #aiImageGenerationForm="ngForm">
        <textarea type="text" [(ngModel)]="aiImageGenerationModel.prompt" required name="prompt" #promptInput="ngModel"
          (blur)="aiImageGenerationModel.prompt = aiImageGenerationModel.prompt!.trim()"
          placeholder="Describe what you want the AI to create..."
          class="resize-none input-field w-full rounded-xl focus:outline-none " rows="4" cols="100" maxlength="250"></textarea>
        <app-form-validator [control]="promptInput" [fieldName]="'Prompt'"></app-form-validator>
        <!-- <div class="">
                      <label for="fileUpload" class="block font-medium mb-2">Upload a reference image
                        (optional)</label>
                      <div class="relative inline-block w-full">
                        <input type="file"
                          class="border border-gray-300 rounded-lg p-2 w-full reference-file"
                          (change)="onSelect($event)" [accept]="allowedExtensions.join(',')" name="fileUpload"
                          id="fileUpload" #fileUploadRef>
                        @if(aiImageGenerationModel.reference_image ){
                        <span
                          class="absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer text-xl text-gray-400 leading-none"
                          (click)="clearFile(fileUploadRef)" title="Clear file">
                          &times;
                        </span>
                        }
                      </div>
                       @if(fileError){
                    <div class="text-red-500 text-sm mt-2">{{this.fileError}}</div>

                    }

                    </div> -->
        <div class="mb-5 mt-2">
          <label for="pattern" class="required font-medium text-base leading-[18px] text-[#121212] mb-2">Pattern</label>
          <ng-select [(ngModel)]="aiImageGenerationModel.pattern" name="pattern" required clearable="false"
            placeholder="Select Pattern" #patternRef="ngModel"
            class="border border-[#E3E6EE] rounded shadow-none text-sm leading-6 font-medium text-[#15191E] focus:shadow-none"
            appendTo="body">
            <!-- <ng-option [value]="'both'">Both</ng-option> -->
            <ng-option [value]="'style'">Style</ng-option>
            <ng-option [value]="'composition'">Composition</ng-option>
          </ng-select>
          <app-form-validator [control]="patternRef" [fieldName]="'Pattern'"></app-form-validator>
        </div>
        <div class="flex justify-end ">
          <button id="modelSubmitButton" [disabled]="!aiImageGenerationForm.valid || isLoading || fileError" class="flex items-center justify-center py-3 px-3 rounded-full text-base leading-5
           text-white font-medium bg-black cursor-pointer" (click)="GenerateAiImage()"
            type="button">Generate
            @if (isLoading) {
            <span
              class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-[#11111100] ms-2 inline-block"></span>
            }
          </button>
        </div>

        
       
    <div class="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-3">

      <!-- <div class="w-full lg:min-w-[600px] lg:max-w-[600px] min-h-[420px] shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white bg-nav-tabs">
        <ul class="flex flex-nowrap items-center text-nowrap cursor-pointer mb-2 list-none p-0 m-0 overflow-x-auto">
          <li class="nav-item">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'Original'}"
                  (click)="setTab('Original')">
                  See Original
              </a>
          </li>
          <li class="nav-item ms-2">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'Removed-background'}" (click)="setTab('Removed-background')">
                  Removed Background
              </a>
          </li>
          @if (backgroundRemovalRequestModel.image) {
            <div class="ms-auto mt-2">
              <span>
                <img (click)="clear()" src="../../../../../../../assets/images/reset.svg" title="reset" alt="reset" height="18" width="18"
                  class="w-6 h-6 cursor-pointer" />
              </span>
            </div>
          }
      </ul>


        @if(!backgroundRemovalRequestModel.image){
        <div class="image-preview">
          <p>No image uploaded yet</p>
        </div>
        }
        @else {
          @if(activeTab === 'Original'){
            <div class="image-preview">
              <img [src]="this.imageUrl" alt="Uploaded" />
            </div>
          }
          @else {
            @if(isLoading){
              <div class="rounded-2xl">
                <div class="h-[400px] w-full bg-gray-400 rounded animate-pulse"></div>
              </div>
              }
             @else if(backgroundRemovalResponseModel.base64_image){
               <div class="image-preview1">
                 <img [src]="getImageSource" alt="Removed Background" />
               </div>
             }

          }
        }


      </div> -->

      <!-- <div class="w-full shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white">
      <h2 class="text-base sm:text-lg text-gray-600 text-center font-medium mb-4">Click here to download</h2>

        <button type="submit" (click)="downloadImage()" [disabled]="!backgroundRemovalResponseModel.base64_image"
          class="flex items-center justify-center py-3 w-full rounded-full text-base leading-5
           text-white font-medium bg-black">
           Download Image
          @if(isDownloading){
          <span
            class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-white ms-2"></span>
          }
        </button>
      </div> -->
    </div>
    







    <div class="flex flex-col gap-3 mt-7 w-full">

      <div class="w-full shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white">
        <h2 class="text-base sm:text-lg text-gray-600 text-center font-medium mb-4">Preview Image</h2>
        <div class="h-[280px] sm:h-[380px] ">
            @if (aiGeneratedImages.length === 0) {
           <div class="image-preview">
          <p>No image generated yet</p>
        </div>
    }
        @else if (isLoading) {
          <div class="rounded-2xl">
            <div class="h-[280px] sm:h-[380px] w-full bg-[#2a2a40] rounded animate-pulse"></div>
          </div>
        } @else {
        @if(aiGeneratedImages.length > 0){
        @if(aiGeneratedImages.length === 1){
          <div class="flex justify-center items-center h-full ">
          <img class="w-full h-full object-contain" [src]="aiGeneratedImages[0] + this.token"
            alt="Main Image">
            
        </div>
        }
      
        <!-- @else {
        <div>
          <div class="try-it-result-area" id="place_holder_picture_model">
            <img class="placeholder-image"
              [src]="proxyServiceFetchURLService.getImageUrl(aiGeneratedImages[selectedImageIndex])" alt="Main Image">
          </div>
          <div class="thumbnail-container">
            @for (item of aiGeneratedImages; track $index;let i = $index) {
            <div class="thumbnail" [class.active]="i === selectedImageIndex" (click)="selectImage(i)">
              <img [src]="proxyServiceFetchURLService.getImageUrl(item)" alt="Thumbnail">
            </div>
            }
          </div>


        </div>
        } -->
        }
      }
      </div>
      
  </div>

        <div class="w-full shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white">
      <h2 class="text-base sm:text-lg text-gray-600 text-center font-medium mb-4">Click here to download</h2>
          @if(aiGeneratedImages.length){
          <div class="flex flex-col gap-3">
            @for (item of downloadableFiles; track $index) {
            
              <button (click)="downloadAiGeneratedImage(item)" type="button"
                class="flex items-center justify-center py-3 px-3 rounded-full text-base leading-5 text-white font-medium bg-black cursor-pointer">
                Download {{item.toUpperCase()}}
                @if(getLoadingState(item)){
                <span
                  class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-[#11111100] ms-2 inline-block"></span>
                }
              </button>
            
            }

          </div>
          }
        </div>
</div>
      </form>
    </div>
  </div>
</div>